<div class="loading" *ngIf="!loaded"></div>
<div *ngIf="loaded">
    <div class="top-header spaceBtwn" *ngIf="this.type !== 'add'">
      <div class="sm-12 item-middle">
        <div>
            <div class="head-one header_text">{{'Edit subjects' | translate}} {{this.type}}</div>
            <div class="sub_header_text">{{this.projectData?.name}}, {{this.projectData?.country?.name}}</div>
        </div>
      </div>
    </div>
</div> 
<div class="pre-white " *ngIf="subjectList?.length && loaded" [style.width]="this.type !== 'add'?'471px':'512px'" [ngClass]="this.type !== 'add'?'pad20':'pad30'">
    <div class="spaceBtwn" *ngIf="this.type == 'add'">
        <div class="sm-12 item-middle">
          <div>
              <div ><label class="form-title">{{'Add subjects' | translate}}</label> </div>
              <div><label class="label-light">{{this.projectData?.name}}, {{this.projectData?.country?.name}}</label></div>
          </div>
        </div>
    </div>
    <div [ngClass]="this.type == 'add'?'marT20':''"><label class=" labeltxt" [ngClass]="textDir=='ltr'?'marR20':'marL20'">{{'Add all subjects to be included' | translate}}</label></div>

    <div class="white" *ngIf="this.type !== 'add'" [style.height]="this.subjectState=='setup'?'345px':''" >
        <form class="form-inline">
            <div class="flexStart marT10">
                <div class="labl-wid"><label class="label-light">{{'Assigned' | translate}}</label></div>
                <div class="slist txtW marB25" >
                    <div *ngFor="let item of mySelectedSubjectsList">
                    <p class="labeltxt">{{item.name|ucfirst}}
                        <span [ngClass]="textDir=='ltr'?'pull-right':'pull-left'">
                        <a (click)='removeSubject(item)' class="edit dotted-txt" >
                            {{'Remove' | translate}}</a>
                        </span>
                    </p>
                    </div>
                </div>
            </div>

            <!-- <div class="form-inline" [style.padding-top]="this.subjectState=='setup'?'20px':'10px'"> -->
                <div class="flexStart flex-vert-centre">
                    <div class="labl-wid">
                        <label class="label-light">{{'Add new subject' | translate}}</label>
                    </div>
                    <div class="txtW-list font12 slist-dropdwn" [dir]="textDir">
                        <input ngui-auto-complete no-match-found-text='No Result Found'
                        type="text" class="form-control" placeholder="{{'Enter new subject' | translate}}"
                        [list-formatter]="myListFormatter"
                        [value-formatter]="myValueFormatter"
                       
                        [(ngModel)]="subject" [source]="this.subjectList" [ngModelOptions]="{standalone: true}" [dir]="textDir"/>
                    
                    </div>
                    <div class="flex-vert-centre" >
                        <a (click)='onAddSubject(subject)' class="btn primary " [ngClass]="textDir=='rtl'?'marR10':'marL10'">{{'Add' | translate}}</a>
                    </div>
                    <br style="clear: left;" />
                   </div>

            <div  >
                <!-- <ng-container *ngIf="this.subjectState=='view'"> -->
                <ng-container *ngIf="this.type !== 'add'">
                <div class="lineHgt15 flexStart marT20" >
                    <i class="icon icon-info padT3 info-txt" [dir]="textDir"></i>
                   <div class="marB10"><label class="info-txt">{{'When a subject is removed' | translate}}</label></div>
                </div>
            </ng-container>
            </div>
           
        </form>
    </div>
    <div class="white" *ngIf="this.type == 'add'" [style.height]="this.subjectState=='setup'?'365px':''" >
        <form class="form-inline">
            <div class="row flexStart marB20 marT15">
                <div class="labl-wid marR10">
                    <label class=" label-light" >{{'Add a subject' | translate }}</label>
                </div>
                <div class="txtW font12">
                    <input ngui-auto-complete no-match-found-text='No Result Found'
                    type="text" class="form-control" placeholder="ex. Mathematics"
                    [list-formatter]="myListFormatter"
                    [value-formatter]="myValueFormatter"
                    
                    [(ngModel)]="subject" [source]="this.subjectList" [ngModelOptions]="{standalone: true}" [dir]="textDir"/>
                
                </div>
                <div class="marL15">
                    <button (click)='onAddSubject(subject)' class="btn primary add-btn">{{'Add' | translate}}</button>
                </div>
                <br style="clear: left;" />
            </div>

            <div class="row flexStart marB20">
                <div class="labl-wid marT20 marR10"><label class="label-light" >{{'Subjects added' | translate }}</label></div>
                <div class="slist marT20  txtW" >
                    <label class="info-txt" *ngIf="mySelectedSubjectsList.length==0">({{'Subjects will be listed here' | translate }})</label>
                    <div *ngFor="let item of mySelectedSubjectsList let i = index">
                    <p class="labeltxt">{{item.name|ucfirst}}
                        <span class="pull-right">
                        <a (click)='removeSubject(item)' class="edit dotted-txt" >
                            <i class="glyphicon glyphicon-remove"></i>{{'Remove' | translate}}</a>
                        </span>
                    </p>
                    </div>
                </div>
            </div>

            <!-- <div class="form-inline" [style.padding-top]="this.subjectState=='setup'?'20px':'10px'"> -->
                

            <div *ngIf="this.type !== 'add'">
                <!-- <ng-container *ngIf="this.subjectState=='view'"> -->
                <ng-container >
                    <div class="lineHgt15 opac-5 flexStart marT20" >
                        <i class="icon icon-info " style="margin-right: 7px;"></i>
                    <div style="line-height: 12px;">{{'When a subject is removed' | translate}}</div>
                    </div>
                </ng-container>
            </div>
           
        </form>
    </div>
</div>
